import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "n-launcher",
  "data-qa": "launcher.page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "n-launcher__logo" })
], -1)
const _hoisted_3 = { class: "n-launcher__search" }
const _hoisted_4 = { class: "n-launcher__items" }
const _hoisted_5 = ["onClick", "data-qa"]
const _hoisted_6 = { class: "item__icon-wrapper" }
const _hoisted_7 = { class: "item__content" }
const _hoisted_8 = { class: "item__title heading-l" }
const _hoisted_9 = { class: "item__description label-s" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NInput = _resolveComponent("NInput")!
  const _component_NIcon = _resolveComponent("NIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NInput, {
          "suffix-icon": "search",
          clearable: "",
          modelValue: _ctx.inputText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputText) = $event)),
          "data-qa": "launcher.input.search"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedItems, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          role: "button",
          class: _normalizeClass(_ctx.getItemClasses(item)),
          key: index,
          onClick: ($event: any) => (_ctx.launcherItemClick(item)),
          "data-qa": _ctx.generateId(item.path || item.name)
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_NIcon, {
              class: "item__icon",
              name: item.icon
            }, null, 8, ["name"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.description), 1)
          ])
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}